import { render } from "./AdminControlView.vue?vue&type=template&id=cd8cd71c"
import script from "./AdminControlView.ts?vue&type=script&lang=js"
export * from "./AdminControlView.ts?vue&type=script&lang=js"

import "./AdminControlView.vue?vue&type=style&index=0&id=cd8cd71c&lang=css"

import exportComponent from "/home/gitlab-runner/builds/snj4qLhS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__